import { useValueEffect, useResizeObserver } from '@react-aria/utils';
import { Children, useRef, useCallback, useLayoutEffect } from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const useOverflow = /* @__PURE__ */ __name((children, childQuerySelector) => {
  const childArray = Children.toArray(children);
  const ref = useRef(null);
  const [visibleItems, setVisibleItems] = useValueEffect(childArray.length);
  const updateOverflow = useCallback(() => {
    const computeVisibleItems = /* @__PURE__ */ __name((visibleItems2) => {
      var _a, _b;
      const currListRef = ref.current;
      if (!currListRef) {
        return childArray.length;
      }
      const containerOffsetPadding = 40;
      const listItems = [...currListRef.querySelectorAll(childQuerySelector)];
      const containerWidth = currListRef.offsetWidth - containerOffsetPadding;
      const hasEllipsis = childArray.length > visibleItems2;
      let calculatedWidth = 0;
      let updatedVisibleItems = 0;
      calculatedWidth += ((_a = listItems.shift()) == null ? void 0 : _a.scrollWidth) || 0;
      updatedVisibleItems++;
      if (hasEllipsis) {
        calculatedWidth += ((_b = listItems.pop()) == null ? void 0 : _b.scrollWidth) || 0;
      }
      if (calculatedWidth >= containerWidth) {
        updatedVisibleItems--;
      }
      for (const { scrollWidth } of listItems) {
        calculatedWidth += scrollWidth;
        if (calculatedWidth < containerWidth) {
          updatedVisibleItems++;
        }
      }
      return updatedVisibleItems;
    }, "computeVisibleItems");
    setVisibleItems(function* () {
      yield childArray.length;
      const updatedVisibleItems = computeVisibleItems(childArray.length);
      yield updatedVisibleItems;
      if (updatedVisibleItems < childArray.length) {
        yield computeVisibleItems(updatedVisibleItems);
      }
    });
  }, [childArray.length, setVisibleItems, childQuerySelector]);
  useResizeObserver({ ref, onResize: updateOverflow });
  useLayoutEffect(updateOverflow, [updateOverflow]);
  return { visibleItems, childArray, ref };
}, "useOverflow");

export { useOverflow };
//# sourceMappingURL=use-overflow.js.map
